/**
 * @generated SignedSource<<34ae59634baa8d0e41a96af741cec083>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SimpleMenuNavigationItem_navigationItemDetails",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "iconClass",
      "storageKey": null
    }
  ],
  "type": "NavigationItem",
  "abstractKey": null
};

node.hash = "2a5b8f936837a416498800a2b212b55e";

module.exports = node;
